import Abstract from './abstract';

export class Library extends Abstract {}
